/** Extensions we persist and show as downloadable Graph-mail documents. */
const DOCUMENT_EXTENSIONS = new Set(["pdf", "xlsx", "xls"]);

/** True when a Graph-mail attachment is a PDF or Excel file, not a photo. */
export function isGraphMailDocumentFilename(filename: string): boolean {
  const name = filename.split(/[/\\]/).pop() ?? filename;
  const dot = name.lastIndexOf(".");
  if (dot <= 0 || dot === name.length - 1) return false;
  return DOCUMENT_EXTENSIONS.has(name.slice(dot + 1).toLowerCase());
}
